import {
    SET_LOGGED_IN,
    LOGOUT,
    RECEIVED_AUTHED_USER,
    SET_ERROR,
    CLEAR_ERROR,
    LOADING_UPDATED,
    LOADING_SUCCESS,
    LOADING_FINISHED,
    SET_SNACKBAR,
    CLEAR_SNACKBAR,
    RECEIVED_PERSON,
} from '../constants';

export const setLoggedIn = (loggedIn) => {
    return {
        type: SET_LOGGED_IN,
        loggedIn,
    };
};

export const logout = () => {
    return {
        type: LOGOUT,
    };
};

export const receivedAuthedUser = (user) => {
    return {
        type: RECEIVED_AUTHED_USER,
        user,
    };
};

export const setError = (messageLines, options) => {
    return {
        type: SET_ERROR,
        messageLines,
        options,
    };
};

export const clearError = () => {
    return {
        type: CLEAR_ERROR,
    };
};

export const setLoadingUpdated = (message, graphic) => {
    return {
        type: LOADING_UPDATED,
        message,
        graphic,
    };
};

export const setLoadingFinished = () => {
    return {
        type: LOADING_FINISHED,
    };
};

export const setSnackbar = (message, callback) => {
    return {
        type: SET_SNACKBAR,
        message,
        callback,
    };
};

export const clearSnackbar = () => {
    return {
        type: CLEAR_SNACKBAR,
    };
};

export const receivedPerson = (person) => {
    return {
        type: RECEIVED_PERSON,
        person,
    };
};



// WEBPACK FOOTER //
// ./scripts/actions/environment.js